import { render, staticRenderFns } from "./AegUpdateTransaction.vue?vue&type=template&id=a81b94cc"
import script from "./AegUpdateTransaction.vue?vue&type=script&lang=js"
export * from "./AegUpdateTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports